<template>
  <CDialog
    :visible.sync="currentVisible"
    width="450px"
    submittable
    :submit-label="$t('Delete')"
    submit-btn-type="danger"
    :submit-loading="loading"
    persistent
    @submit="submit"
  >
    <div class="dialog-header">
      <div class="icon-box">
        <CIcon name="highlight_off" material class="icon" />
      </div>
      <div class="dialog-title">{{ $t('Delete group') }}</div>
    </div>

    <div class="dialog-body text-center">
      <p>{{ $t("This operation can't be canceled.") }}</p>
    </div>
  </CDialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import CDialog from '@/components/uikit/CDialog';
import CIcon from '@/components/uikit/CIcon';

const messages = {
  en: {
    'Delete group': 'Delete group',
    "This operation can't be canceled.": "This operation can't be canceled.",
    Delete: 'Delete',
    Group: 'Group',
  },
  ja: {
    'Delete group': 'グループを削除します。',
    "This operation can't be canceled.": 'この操作は取り消しができません。',
    Delete: '削除する',
    Group: 'グループ',
  },
};

export default {
  name: 'ModalDeleteGroup',
  i18n: { messages },
  components: { CDialog, CIcon },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState('groups', {
      groupBy: state => state.type,
      groupId: state => state.selectedId,
    }),

    currentVisible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    ...mapActions('groups', ['delete']),

    async submit() {
      try {
        this.loading = true;
        await this.delete({ id: this.groupId });
        await this.$alpha.notify.success('delete', this.$t('Group'));
        this.currentVisible = false;
        this.$emit('success');
      } catch (e) {
        await this.$alpha.notify.error('delete', this.$t('Group'));
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-header {
  padding: 15px;

  .dialog-title {
    text-align: center;
    font-size: 26px;
    margin: 30px 0 -10px;
  }
}

.icon-box {
  text-align: center;

  & > i {
    font-size: 90px;
    color: $danger-color;
  }
}
.dialog-body {
  position: relative;
  padding: 15px;
}
</style>
